/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetLocationResponse } from './GetLocationResponse';
import {
    GetLocationResponseFromJSON,
    GetLocationResponseFromJSONTyped,
    GetLocationResponseToJSON,
    GetLocationResponseToJSONTyped,
} from './GetLocationResponse';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface PaginatedResultOfGetLocationResponse
 */
export interface PaginatedResultOfGetLocationResponse {
    /**
     * 
     * @type {Array<GetLocationResponse>}
     * @memberof PaginatedResultOfGetLocationResponse
     */
    items?: Array<GetLocationResponse>;
    /**
     * 
     * @type {any}
     * @memberof PaginatedResultOfGetLocationResponse
     */
    lastSelectedId?: any | null;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof PaginatedResultOfGetLocationResponse
     */
    pageNumber?: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof PaginatedResultOfGetLocationResponse
     */
    pageSize?: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof PaginatedResultOfGetLocationResponse
     */
    totalCount?: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {boolean}
     * @memberof PaginatedResultOfGetLocationResponse
     */
    hasNextPage?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PaginatedResultOfGetLocationResponse
     */
    hasPreviousPage?: boolean;
}

/**
 * Check if a given object implements the PaginatedResultOfGetLocationResponse interface.
 */
export function instanceOfPaginatedResultOfGetLocationResponse(value: object): value is PaginatedResultOfGetLocationResponse {
    return true;
}

export function PaginatedResultOfGetLocationResponseFromJSON(json: any): PaginatedResultOfGetLocationResponse {
    return PaginatedResultOfGetLocationResponseFromJSONTyped(json, false);
}

export function PaginatedResultOfGetLocationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedResultOfGetLocationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(GetLocationResponseFromJSON)),
        'lastSelectedId': json['lastSelectedId'] == null ? undefined : json['lastSelectedId'],
        'pageNumber': json['pageNumber'] == null ? undefined : ApiUserTasksGetPageParameterFromJSON(json['pageNumber']),
        'pageSize': json['pageSize'] == null ? undefined : ApiUserTasksGetPageParameterFromJSON(json['pageSize']),
        'totalCount': json['totalCount'] == null ? undefined : ApiUserTasksGetPageParameterFromJSON(json['totalCount']),
        'hasNextPage': json['hasNextPage'] == null ? undefined : json['hasNextPage'],
        'hasPreviousPage': json['hasPreviousPage'] == null ? undefined : json['hasPreviousPage'],
    };
}

export function PaginatedResultOfGetLocationResponseToJSON(json: any): PaginatedResultOfGetLocationResponse {
    return PaginatedResultOfGetLocationResponseToJSONTyped(json, false);
}

export function PaginatedResultOfGetLocationResponseToJSONTyped(value?: PaginatedResultOfGetLocationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(GetLocationResponseToJSON)),
        'lastSelectedId': value['lastSelectedId'],
        'pageNumber': ApiUserTasksGetPageParameterToJSON(value['pageNumber']),
        'pageSize': ApiUserTasksGetPageParameterToJSON(value['pageSize']),
        'totalCount': ApiUserTasksGetPageParameterToJSON(value['totalCount']),
        'hasNextPage': value['hasNextPage'],
        'hasPreviousPage': value['hasPreviousPage'],
    };
}

